/** *********************************************
  Action creators that produces actions for auth reducer
********************************************** */
import jwtDecode from 'jwt-decode';
import actionTypes from './actionTypes';
import {
  post
} from '../../utils/requests';
import {
  setAuthCookie,
  removeAuthCookie
} from '../../utils/cookies';
import messages from '../../constants/messages';
import { fetchProfile } from '../profile/actionCreators';
import { API_ENPOINTS } from '../../constants/api';
import { acceptEula as acceptEulaRequest } from '../profile/apiRequests';


export const loginRequest = () => ({
  type: actionTypes.LOGIN_REQUEST
});

export const loginSuccess = (userId, eula) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.LOGIN_SUCCESS,
      eula,
      userId
    });
    return dispatch(fetchProfile(userId));
  }
};

export function loginFailure({ status, message, response={}}) {
  let errorMessage = messages.common.error;
  // Show error message from the server response when 401 Unauthorized.
  // It may vary depending on actual reason of refusing
  if (status === 401 && message) {
    errorMessage = message;
  }

  return {
    type: actionTypes.LOGIN_FAILURE,
    errorMessage
  };
}

export function restorePasswordRequest() {
  return {
    type: actionTypes.RESTORE_PASSWORD_REQUEST
  };
}

export function restorePasswordSuccess() {
  return {
    type: actionTypes.RESTORE_PASSWORD_SUCCESS
  };
}

export function restorePasswordFailure() {
  return {
    type: actionTypes.RESTORE_PASSWORD_FAILURE,
    errorMessage: 'Something went wrong'
  };
}

export function resetPasswordRequest() {
  return {
    type: actionTypes.RESET_PASSWORD_REQUEST
  };
}

export function resetPasswordSuccess() {
  return {
    type: actionTypes.RESET_PASSWORD_SUCCESS
  };
}

export function resetPasswordFailure() {
  return {
    type: actionTypes.RESET_PASSWORD_FAILURE,
    errorMessage: messages.common.error
  };
}

export function logoutSuccess() {
  return {
    type: actionTypes.LOGOUT
  };
}

export function clearErrors() {
  return {
    type: actionTypes.CLEAR_AUTH_ERRORS
  };
}

export function acceptEulaSuccess() {
  return {
    type: actionTypes.ACCEPT_EULA_SUCCESS,
  };
}

export const fetchAccountStatusSuccess = (eula) => ({
  type: actionTypes.FETCH_ACCOUNT_STATUS_SUCCESS,
  eula,
});

export function logout() {
  return (dispatch) => {
    removeAuthCookie();
    localStorage.removeItem('searchFilter');
    dispatch(logoutSuccess());
  }
}

export function login(email, password, keepSignedIn=false) {
  return (dispatch) => {
    const endpoint = API_ENPOINTS.login;
    const payload = {
      email,
      password,
      keepSignedIn
    };

    dispatch(loginRequest());

    return post(endpoint, payload)
      .then(({ token, eula }) => {
        const tokenPayload = jwtDecode(token);
        setAuthCookie(token, tokenPayload.exp, keepSignedIn);
        dispatch(loginSuccess(tokenPayload.jti, eula));
      })
      .catch((error) => {
        dispatch(loginFailure(error));
      })
  };
}

export function restorePassword(email) {
  return (dispatch) => {
    const endpoint = API_ENPOINTS.passwordRecovery;
    const payload = { email };

    dispatch(restorePasswordRequest());

    return post(endpoint, payload)
      .then(() => {
        dispatch(restorePasswordSuccess());
      })
      .catch(() => {
        dispatch(restorePasswordFailure());
      })
  };
}

export function resetPassword(id, password, code) {
  return (dispatch) => {
    const endpoint = API_ENPOINTS.confirmPasswordRecovery;
    const payload = {
      id,
      password,
      code
    };

    dispatch(resetPasswordRequest());

    return post(endpoint, payload)
      .then(() => {
        dispatch(resetPasswordSuccess());
      })
      .catch((error) => {
        dispatch(resetPasswordFailure(error));
      })
  };
}

export const acceptEula = () => {
  return (dispatch) => {
    return acceptEulaRequest()
      .then(() => {
        dispatch(acceptEulaSuccess());
      });
  };
};



// WEBPACK FOOTER //
// src/actions/auth/actionCreators.js